import { render, staticRenderFns } from "./HigherHighHigherLow.vue?vue&type=template&id=f7bc440a&scoped=true"
import script from "./HigherHighHigherLow.vue?vue&type=script&lang=js"
export * from "./HigherHighHigherLow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7bc440a",
  null
  
)

export default component.exports